import JsonField from './JsonField.js'
import formats from '../../../api/formats'
import forms from '../../common/forms.js'
import people from '../../people'
import favorite from '../../favorite'
import dialogs from '../../common/dialogs.js'

export default
class ContactField extends JsonField {
  isIndividual () {
    return this.ref && this.cxt.getFieldObject(this.ref).type === 'INDIVIDUAL'
  }
  getDescription (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return this.isIndividual() ? `${obj.name}` : `${obj.nameForCompany}`
  }
  open (model, onChange) {
    let key = this.getCode(model)
    let fstrategy = this.getStrategy()
    if (!fstrategy) {
      return
    }
    Promise.resolve(this.isIndividual())
    .then(isIndividual => {
      return new Promise((resolve, reject) => {
        if (isIndividual) {
          this.cxt.getReferencePerson(model, this.name)
          .then((personId) => {
            people.getIndividual(personId).then((person) => {
              fstrategy.setParentProps(person)
              forms.openFormStg(fstrategy, key).then((key) => {
                resolve(key)
              })
            })
          })
        } else {
          const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
          if (!this.checkCompanyRefCode(companyRefCode)) {
            reject(`Not valid RefCode [${companyRefCode}]`)
          }
          favorite.getCompanyRef(companyRefCode).then((props) => {
            favorite.openCompanyContact(key, props.ref.ref, props.ref.caption, props.clientCompanyId).then((key) => {
              resolve(key)
            })
          })
        }
      })
    })
    .then(key => {
      this.setCode(model, key, onChange)
    })
  }
  selectIndividualContacts (model) {
    return new Promise((resolve, reject) => {
      const getQuery = () => {
        return this.getCode(model) ? this.getCode(model) : ''
      }
      this.cxt.getReferencePerson(model, this.name)
      .then((personId) => {
        let companyInn
        // companyInn = this.getReferenceCompanyInn(model, fieldName)
        companyInn = companyInn ? companyInn + '' : null
        people.getIndividual(personId).then((person) => {
          let contacts = person.contacts
          if (contacts.length > 0) {
            people.selectContactByIndividual(this.cxt.context, person, getQuery, companyInn)
            .then((data) => resolve(data))
          } else {
            let fstrategy = this.getStrategy()
            fstrategy.setParentProps(person)
            forms.openFormStg(fstrategy, null).then((data) => {
              resolve([data])
            })
          }
        })
      })
      .catch(() => reject())
    })
  }
  selectCompanyContacts (model) {
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    if (!this.checkCompanyRefCode(companyRefCode)) {
      return Promise.reject(`Not valid RefCode [${companyRefCode}]`)
    }
    return new Promise((resolve, reject) => {
      people.selectContactByCompany(this.cxt.context, companyRefCode)
      .then((data) => resolve(data))
    })
  }
  select (model, onChange) {
    Promise.resolve(this.isIndividual())
    .then(isIndividual => {
      if (isIndividual) {
        return this.selectIndividualContacts(model)
      } else {
        return this.selectCompanyContacts(model)
      }
    })
    .then((values) => {
      if (Array.isArray(values) && values.length > 0) {
        this.setCode(model, values[0], onChange)
      }
    })
    .catch(error => {
      console.log('ContactField:error', error)
    })
  }
  checkCompanyRefCode (refCode) {
    if (formats.isRefCode(refCode)) {
      return true
    }
    dialogs.message(this, 'Совет', 'Сначала выберите компанию')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/ContactField.js